export enum Themes {
  SYSTEM = 'system',
  LIGHT = 'light',
  DARK = 'dark',
}

export type ThemesType = Themes.SYSTEM | Themes.LIGHT | Themes.DARK;
